import { motion } from "framer-motion";

const USER_IMG_WINDOW = "https://customer-assets.emergentagent.com/job_pet-care-access/artifacts/nuioa16p_IMG_4034.heic";
const FALLBACK_WINDOW = "https://images.unsplash.com/photo-1694467648694-0c0d5eeeb43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxkb2dzJTIwbG9va2luZyUyMG91dCUyMHdpbmRvd3xlbnwwfHx8fDE3NzU5NzE1MTN8MA&ixlib=rb-4.1.0&q=85";
const USER_IMG_SLEEPING = "https://customer-assets.emergentagent.com/job_pet-care-access/artifacts/iqnrmgct_IMG_1723.heic";
const USER_IMG_OUTDOORS = "https://customer-assets.emergentagent.com/job_pet-care-access/artifacts/nisubstg_IMG_0397.heic";
const USER_IMG_COUCH = "https://customer-assets.emergentagent.com/job_pet-care-access/artifacts/fzt62bub_IMG_3626.heic";

const photos = [
  {
    src: FALLBACK_WINDOW,
    heicSrc: USER_IMG_WINDOW,
    alt: "Oreo Henderson and friends looking out the window",
    caption: "Oreo and friends - forever in our hearts",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    heicSrc: USER_IMG_OUTDOORS,
    src: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&q=80",
    alt: "The fur babies enjoying the yard",
    caption: "Soaking up the sunshine",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    heicSrc: USER_IMG_SLEEPING,
    src: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&q=80",
    alt: "The babies sleeping together",
    caption: "Snuggled up - the sweetest family",
    span: "md:col-span-2",
  },
  {
    heicSrc: USER_IMG_COUCH,
    src: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=600&q=80",
    alt: "Two fur babies cuddling on the couch",
    caption: "Couch cuddles - pure love",
    span: "md:col-span-2",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-[#F2EFEB]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          className="mb-16 text-center"
        >
          <p className="font-body text-xs font-bold tracking-[0.2em] uppercase text-[#C0603A] mb-4">
            Fur Family
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#2C2C2A] font-medium">
            Gallery
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 auto-rows-[220px] md:auto-rows-[200px]">
          {photos.map((photo, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className={`${photo.span} rounded-3xl overflow-hidden relative group cursor-pointer`}
              data-testid={`gallery-photo-${i}`}
            >
              <picture>
                {photo.heicSrc && <source srcSet={photo.heicSrc} type="image/heic" />}
                <img
                  src={photo.src}
                  alt={photo.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </picture>
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2A]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <p className="font-body text-sm text-white">{photo.caption}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
